<template>
  <v-card
    flat
    class="rounded-lg clients-card"
    height="calc(100vh - 160px)"
    style="overflow-y: auto; transition: all ease .3s"
    :width="expanded ? '' : '190px'"
  >
    <v-card-title class="pb-0">
      Clientes

      <v-spacer></v-spacer>

      <v-btn icon small color="primary" @click="expanded = !expanded">
        <v-icon>
          {{ expanded ? "mdi-chevron-left" : "mdi-chevron-right" }}
        </v-icon>
      </v-btn>
    </v-card-title>

    <v-card-text>
      <div style="position: sticky; top: 0; z-index: 2" class="pt-4 white">
        <v-text-field
          outlined
          solo
          flat
          prepend-inner-icon="mdi-magnify"
          v-model="search"
          dense
          hide-details
          label="Buscar cliente..."
        ></v-text-field>

        <v-card flat rounded="lg" color="grey lighten-4" class="my-2">
          <v-card-text class="py-2">
            <div class="text--primary">
              Filtrar por:
            </div>

            <v-checkbox
              label="Alquileres pendientes"
              hide-details
              dense
              v-model="pendingRent"
              class="mt-0"
            ></v-checkbox>
          </v-card-text>
        </v-card>

        <v-divider></v-divider>
      </div>

      <v-list link dense two-line style="overflow-y: auto">
        <v-list-item-group v-model="selected" color="primary">
          <template v-for="(client, index) in filteredClients">
            <v-list-item
              :key="client.id"
              active-class="secondary lighten-2"
              :class="index % 2 ? 'grey lighten-4' : ''"
              :value="client"
            >
              <v-list-item-content>
                <v-list-item-title
                  v-html="client.profile.name"
                ></v-list-item-title>
                <v-list-item-subtitle
                  v-html="client.profile.address"
                ></v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
          </template>
        </v-list-item-group>
      </v-list>
    </v-card-text>
  </v-card>
</template>

<script>
import { ListContacts } from "@/graphql/queries/directory";

export default {
  data: () => ({
    clients: [],
    expanded: true,
    selected: null,
    search: null,
    pendingRent: false
  }),

  computed: {
    filteredClients() {
      if (this.search) {
        const text = this.search.toUpperCase().split(" ");
        return this.clients.filter(item => {
          return text.every(el => {
            return item.profile.name.toUpperCase().includes(el);
          });
        });
      } else {
        return this.clients;
      }
    }
  },

  props: {
    paymentType: {
      type: String,
      required: true
    }
  },

  watch: {
    paymentType() {
      this.fetchClients();
    },

    selected(val) {
      this.$emit("select", val);
    },

    pendingRent() {
      this.fetchClients();
    }
  },

  created() {
    this.fetchClients();
  },

  methods: {
    fetchClients() {
      this.$apollo
        .query({
          query: ListContacts,
          variables: {
            roles: [this.paymentType],
            pendingRent: this.pendingRent
          }
        })
        .then(res => {
          this.clients = res.data.listContacts;

          if (this.client) {
            this.client = this.clients.find(o => o.id == this.client.id);
          }
        });
    }
  }
};
</script>
